import { NAV_BAR_HEIGHT } from "src/components/NavBar";
import { useSafeArea } from "src/swsh-native";

const useModularNavBarSizing = () => {
	const safeArea = useSafeArea();

	return {
		top: safeArea.top,
		height: NAV_BAR_HEIGHT,
	};
};
export default useModularNavBarSizing;
